<template>
  <div>
    <div class="header-all">
      <v-header :type="showType.H5"></v-header>
    </div>
    <v-result  :type="showType.H5" v-if="showTop" :types="headType.h5Main">
      <v-banner :banners="banner"></v-banner>
      <v-cate :cates="category" :cdn="cdn" ></v-cate>
      <v-newHomePage v-if="!isWeixin" :datas="newhomePageData" :hotGoodsIdx="hotGoodsIdx" :goodShop="goodShop" :jdShareRatio="jdShareRatio"></v-newHomePage>
      <!--<v-navRe :navs="navRecommend" :cdn="cdn" ></v-navRe>-->
      <!--<v-idxClass :recommend="onePrice"></v-idxClass>-->
      <!--<v-idxClass :recommend="idx23"></v-idxClass>-->
      <!--<v-idxClass :recommend="chaozhi"></v-idxClass>-->
      <!--<v-idxClass :recommend="idx27"></v-idxClass>-->
      <!--<v-idxClass :recommend="top"></v-idxClass>-->
    </v-result>
    <div class="h5-foot-contain">
      <div class="banner-contain">
        <v-totalheader :type="headType.h5Main"></v-totalheader>
      </div>
    </div>
  </div>
</template>
<script>
  import Banner from './taoke/Banner.vue';
  import Header from './taoke/Header.vue';
  import Category from './taoke/Category.vue';
  import NavRecommend from './taoke/NavRecommend.vue';
  import TotalHeader from './taoke/TotalHeader.vue';
  import Result from './Result.vue';
  import IdxClass from './taoke/IdxClass.vue';
  import NewHomePage from './taoke/NewHomePage.vue';
  export default {
    name: 'h5',
    data () {
      return {
        cdn:'',
        showHeader:true,
        showTop:false,
        onePrice:{},//一元包邮
        chaozhi:{},//超值
        top:{},//排行榜
        idx23:{},//专题23
        idx27:{},//专题27
        banner:[],//banner
        category:[],//首页品牌
        recommend:[],//推荐
        navRecommend:[],//首页推荐
        newhomePageData:[],
        hotGoodsIdx:[],//热门品类滑动图
        goodShop:[],//好店推荐
        jdShareRatio: 0//京东佣金比
      }
    },
    components:{
      'v-cate':Category,
      'v-banner':Banner,
      'v-header':Header,
      'v-navRe':NavRecommend,
      'v-result':Result,
      'v-totalheader':TotalHeader,
      'v-idxClass':IdxClass,
      'v-newHomePage':NewHomePage
    },
    watch:{
      param:function(p){
        this.showTop = true;
      }
    },
    created(){
      document.title = this.isWeixin ? "一起买买买" : "一起买买买官网-社交电商平台，天猫淘宝京东优惠券-yiqimmm.com一起买买买";
      var metaEls = document.getElementsByTagName("meta")
      metaEls["keywords"].content = "一起买买买,一起买买买官网,优惠券,返利,淘宝优惠券,天猫优惠券,京东优惠券,9块9包邮,折扣";
      metaEls["description"].content = "一起买买买官网，新零售社交电商平台，人人必备的淘宝天猫京东蘑菇街购物省钱神器！一起省钱买，一起分享赚！";

      this.$route.query.unionId && this.setCookie("unionId",this.$route.query.unionId,30);
      let seft = this;
      this.http.get(this.https.sysInit).then(function(response){
        response.data.jdShareRatio && (seft.jdShareRatio = response.data.jdShareRatio);
        var tempCategory = [];
        response.data.indexNavPath.forEach(function(item,index,array){
          if(item.classType===seft.classType.Category){
            tempCategory.push(item);
          }else if(item.classType===seft.classType.NavRecommend){
            seft.navRecommend.unshift(item);
          }
        });
        seft.category = tempCategory.sort(function(a,b){return a.idx - b.idx});

        var tempBannerList = [];
        var tempNewHomePageData = [];
        var idx6001493 = [];
        var temp6001493Idx = [];
        var idx1264 = [];
        var temp1264Idx = [];
        response.data.d.forEach(function(item){

          switch (item.idx){
            case seft.public.classIdx.onePrice:{
              seft.onePrice = item;
              break;
            }
            case seft.public.classIdx.chaozhi:{
              seft.chaozhi = item;
              break;
            }
            case seft.public.classIdx.top:{
              seft.top = item;
              break;
            }
            case 23:{
              seft.idx23 = item;
              break;
            }
            case 27:{
              seft.idx27 = item;
              break;
            }
            default:{
            }
          }



          if(item.classType && item.classType===seft.classType.newHomePage){
            if(item.idx==600||item.idx==1493){
              //热门品类
              idx6001493 = item.appShowTypeParam.split(",");
            }else if(item.idx==1264){
              idx1264 = item.appShowTypeParam.split(",");
            }
            tempNewHomePageData.push(item);
          }else if(item.classType && item.classType===seft.classType.Banner){
            tempBannerList.unshift(item);
            seft.recommend.unshift(item);
          }else if(item.classType && (item.classType===seft.classType.newBanner || item.classType===seft.classType.JDBanner) ){
            tempBannerList.unshift(item);
          }else if(item.classType && item.classType===seft.classType.Recommend){
            seft.recommend.unshift(item);
          }
        });

        response.data.d.forEach(function(item){
          idx6001493.indexOf(item.idx.toString()) > -1 && temp6001493Idx.push(item);
          idx1264.indexOf(item.idx.toString()) > -1 && temp1264Idx.push(item);
        });
        temp6001493Idx.sort(function(a,b){return b.order - a.order;});

        //===========================
        for(var i=0;i<idx1264.length;i++){
          for(var j=0;j<temp1264Idx.length;j++){
            if(idx1264[i]==temp1264Idx[j].idx.toString()){
              var temp = temp1264Idx[i];
              temp1264Idx[i] = temp1264Idx[j];
              temp1264Idx[j] = temp;
              break;
            }
          }
        }
          //若下方order排序temp1264Idx打开, 可注释上方二重嵌套for循环
//        temp1264Idx.sort(function(a,b){return b.order - a.order;});
        //===========================

        seft.hotGoodsIdx = temp6001493Idx;
        seft.goodShop = temp1264Idx;
        tempNewHomePageData = tempNewHomePageData.filter(function(a){return [1,2,3,4,12,13,14].indexOf(a.appShowType) > -1});
        seft.newhomePageData = tempNewHomePageData.sort(function(a,b){return b.order - a.order});

        var banner_first;
        var banner_last;
        tempBannerList.forEach(function(b){
          b.idx == 1555 && (banner_first = b);
          b.idx == 1506 && (banner_last = b);
        });
        tempBannerList = tempBannerList.filter(function(b){return b.idx!=1555 && b.idx!=1506});
        tempBannerList.sort(function(a,b){
          return b.order - a.order;
        });
        banner_first && tempBannerList.unshift(banner_first);
        //banner_last && tempBannerList.push(banner_last);
        seft.banner = tempBannerList;

        window.localStorage.setItem("Recommend",JSON.stringify(seft.recommend));
        seft.http.get(seft.https.getCDN).then(function(response){
          seft.cdn = response.data;
          seft.cdns = seft.cdn;
          seft.showTop = true;
        }).catch(function(error){
          console.error(error);
        })
      }).catch(function(error){
        console.error(error);
      });

      var clientWidth = document.documentElement.clientWidth;
      window.onscroll = function(){
        var header_all = document.getElementsByClassName("header-all")[0];
        if(clientWidth){
          var height = 9*375/14;
          var res = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
          var r,g,b,a1,a2;
          if(res <= height){
            r = parseInt(255*res/height);
            g = parseInt(97*res/height);
            b = parseInt(79*res/height);
            a1 = 0.7*res/height + 0.3;
            a2 = res/height;
          }else{
            r = 255, g = 97, b = 79, a1 = 1, a2 = 1;
          }
          header_all && (header_all.style.background = `linear-gradient(rgba(${r},${g},${b},${a1}), rgba(${r},${g},${b},${a2}))`);
        }
      };

    },
    mounted(){
      let uid = this.$route.query.uid;
      if(uid){
        this.setCookie("uid",uid,365);
      }
      let unionId = this.$route.query.unionId;
      if(unionId){
        this.setCookie("unionId",unionId,365);
      }
    },
    methods:{
      setCookie(key, value, day) {
        let date = new Date();
        date.setDate(date.getDate() + day);
        document.cookie = key + '=' + encodeURI(value) + ';expires=' + date;
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// H5.vue?05a10c14